export default __webpack_public_path__ + "static/media/button.76bac306.png";